module.exports = __webpack_public_path__ + "static/tradee_chat-0faaae6d851aa7a95fa188f36c65ec2d.png";